<template>
  <div class="news">
    <!-- banner部分 -->
    <div class="news-banner">
      <div>
        <h2>案例中心</h2>
      </div>
    </div>
    <!-- 导航部分 -->
    <div class="news-nav mb100">
      <div class="container">
        <ul>
          <li :class="index == current ? 'current' : ''" @click="changeTab(index)" v-for="(item, index) in tabList" :key="index">
            <a href="javascript:void(0)">{{ item }}</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 智慧校园的路径导航 -->
    <div v-if="current == 0" class="container-5 bread">
      <span :class="activebread == 0 ? 'active-span' : ''" @click="toAll">全部</span><span> &emsp;&emsp; </span> <span :class="activebread == 2 ? 'active-span' : ''" @click="toSchool">K12</span><span> &emsp;&emsp; </span> <span :class="activebread == 1 ? 'active-span' : ''" @click="toCollege">高校及中职</span>
    </div>
    <!-- 内容部分 -->
    <div class="news-list clearfix">
      <ul v-for="(caseList, index) in caseItem" :key="index" v-show="current + 1 == index" :class="current == index ? 'container showBox' : 'container'">
        <li v-for="(list, inde) in caseList" :key="inde" v-show="index + current1 == inde" class="home-recdyc item1">
          <div class="content container" v-for="(item, number) in list" :key="number" @click="toDeatil(item.title)">
            <div class="content-l">
              <img :src="item.src" alt />
            </div>
            <div class="content-r">
              <h2>{{ item.title }}</h2>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 分页部分 -->
    <div class="news-page container clearfix">
      <ul>
        <li class="back-index" @click="tofirst">
          <a href="javascript:void(0)">首页</a>
        </li>
        <li class="back-index" @click="toprev">
          <a href="javascript:void(0)">上一页</a>
        </li>
        <li :class="index == current1 ? 'current' : ''" @click="changeTab1(index)" v-for="(item, index) in pageList" :key="index">
          <a href="javascript:void(0)">{{ item }}</a>
        </li>
        <li class="back-index" @click="tonext">
          <a href="javascript:void(0)">下一页</a>
        </li>
        <li class="back-index" @click="toend">
          <a href="javascript:void(0)">末页</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'News',
  data() {
    return {
      tabList: ['智慧校园', '智慧社区', '智慧工地', '智慧景区'],
      breadList: ['全部', '高校', 'K12'],
      pageList: ['1', '2', '3'],
      activebread: 0,
      current: 0,
      current1: 0,
      caseItem: {
        1: {
          10: [
            {
              title: '巢湖学院',
              text: '安徽巢湖学院是安徽省属全日制公办本科高校。创建于1977年，前身是巢湖师范专科学校。2002年4月，经教育部批准，升格为本科院校，更名巢湖学院。2006年6月，获批学士学位授予权。2013年6月，顺利通过教育部本科教学工作合格评估。2018年12月，参与教育部本科教学工作审核评估，并获好评。2019年10月，获批...',
              src: require('../../assets/img/case/zhxy_image_0.png'),
            },
            {
              title: '上海工商职业技术学院',
              text: '上海工商职业技术学院（Shanghai Industrial and Commercial Polytechnic），前身为上海新侨职业技术学院，创建于1993年，由上海海外联谊会、上海市海外交流协会、上海市归国华侨联合会、上海中华职业教育社、上海市工商业联合会、中国民主建国会上海市委员会等六个统战系统的社会团体及民主党派共...',
              src: require('../../assets/img/case/zhxy_image_1.png'),
            },
            {
              title: '江苏省盐城技师学院',
              text: '学校创办于上世纪八十年代初期，1994年被国家劳动部评定为全国首批国家级重点技工学校，2007年经江苏省人民政府批准为全省首批副厅级重点技师学院，更名为“江苏省盐城技师学院”。2008年1月增挂江苏联合职业技术学院盐城技师分院校牌。2020年3月，盐城交通技师学院并入江苏省盐城技师学院。',
              src: require('../../assets/img/case/zhxy_image_2.png'),
            },
            {
              title: '盐城生物工程高等职业技术学校',
              text: '盐城生物工程高等职业技术学校（江苏联合职业技术学院盐城生物工程分院），是国家中等职业教育改革发展示范学校、江苏省现代化示范性职业学校、江苏省农业紧缺人才培训基地、江苏省退役士兵职业技能培训学院。 学校前身为“江苏省盐城农业学校”，创办于1952年，1958年创办“江苏盐城农学院...',
              src: require('../../assets/img/case/zhxy_image_3.png'),
            },
            {
              title: '江苏省姜堰中学',
              text: '江苏省姜堰中学（Jiangyan High Schoolof Jiangsu Province），国家级示范性高中、江苏省重点高中、江苏省四星级高中。江苏省姜堰中学创办于1939年，历经三水初级中学、泰县私立荣汉初级中学、存容学塾、苏中姜堰初级中学、泰县姜堰中学等的传承演变。1996年被省教委命名为江苏省姜堰中...',
              src: require('../../assets/img/case/zhxy_image_4.png'),
            },
            {
              title: '江苏省丹阳高级中学',
              text: '江苏省丹阳高级中学（Danyang Senior High School of Jiangsu Province），简称“省丹中”，坐落于江苏省丹阳市，由丹阳市教育局举办，是首批国家级示范高中、江苏省首批四星级高中、江苏省首批重点中学、江苏省创新拔尖人才培养试点学校、江苏省首批高品质示范高中南京大学创新人才培养战略合作伙伴、江苏...',
              src: require('../../assets/img/case/zhxy_image_5.png'),
            },
            {
              title: '江苏省射阳中学',
              text: '江苏省射阳中学（Jiangsu Province Sheyang High School），简称“省射中”，位于江苏省射阳县新城区幸福大道28号。学校是首批国家级示范高中、首批江苏省四星级高中。江苏省射阳中学创办于1943年2月，最初校名为“盐东县立初级中学“，后几经更名。1956年夏，增设高中部，更名为“射阳县中...',
              src: require('../../assets/img/case/zhxy_image_6.png'),
            },
          ],
          11: [
            {
              title: '兴洪中学',
              text: '兴洪中学创办于1994年6月，开苏北民办教育之先河，是宿迁市第一所民办学校。2006年1月，兴洪中学被江苏省教育厅评定为省重点中学，是泗洪县众多民办学校中唯一一家省重点中学。学校位于县城西郊，东邻省道徐宁路西望宁宿徐高速公路，南面是正在崛起的泗洪工业园区，地理位置优越，交通便利，环境...',
              src: require('../../assets/img/case/zhxy_image_7.png'),
            },
            {
              title: '江苏省阜宁中学',
              text: '江苏省阜宁中学（Jiangsu Funing Middle School），简称“阜中”，位于江苏省盐城市阜宁县。学校创办于1923年，1952年学校经江苏省教育厅批准正式定名为江苏省阜宁中学。2001年4月被江苏省教育厅确认为国家级示范高中，2004年3月转评为江苏省四星级高中。',
              src: require('../../assets/img/case/zhxy_image_8.png'),
            },
            {
              title: '江苏省阜宁县实验初级中学',
              text: '阜宁县实验初级中学位于阜宁县城南新区。校区占地228亩，总投资额1.68亿元，办学规模为20轨60个班。新校区交通便捷，设施齐全环境幽雅，气势恢弘，堪称苏北一流的现代化校园。学校先后获得省绿色学校、省优秀教师群体、省和谐教育先进集体、省实施教育现代化工程示范初中、省初中物理学科实验基地...',
              src: require('../../assets/img/case/zhxy_image_9.png'),
            },
            {
              title: '江苏省亭湖高级中学',
              text: '江苏省亭湖高级中学位于盐城市亭湖新区，亭湖大道北侧、兴洋大道东侧，与亭湖区政府隔街相望。2012年盐城市亭湖区政府在盐城市亭湖新区重点打造的民生工程，江苏省亭湖高级中学建成投入使用，盐城市景山中学高中部东迁到新校区，新校区建设“立足四星标准、留足五星空间”，最终打造成全省一流...',
              src: require('../../assets/img/case/zhxy_image_10.png'),
            },
            {
              title: '启东市折桂中学',
              text: '启东折桂中学位于启东市汇龙镇民乐中路580号，占地面积57168平方米（85.7亩），现有班级38个，教职工186人，在校学生总数2000多人。启东折桂中学于2004年在原江苏省启东中学初中部（民办）的基础上创办，2011年春改制为公办学校。2015年3月与江苏省启东中学剥离，正...',
              src: require('../../assets/img/case/zhxy_image_11.png'),
            },
            {
              title: '南通市通州区育才中学',
              text: '南通市通州区育才中学位于江苏省南通市通州区金沙镇，原系江苏省通州高级中学的初中部。2000年经南通市教育局批准为全日制民办中学，2006年8月搬迁南通高新技术产业开发区银河路21号独立办学，2010年下半年学校“回归公办”。 [1]  2014年9月，学校搬迁至新校区。',
              src: require('../../assets/img/case/zhxy_image_12.png'),
            },
          ],
          12: [
            {
              title: '江苏省南通田家炳中学',
              text: '江苏省南通田家炳中学（Nantong Tianjiabing Middle School of Jiangsu Province）位于江苏省南通市，学校是由南通市教育局举办的一所公办初级中学。学校始建于1952年，时名苏北工人技术学校。1954年，更名为“南通市第一初级中学”。 1958年，更名为南通市第三中学。2002年...',
              src: require('../../assets/img/case/zhxy_image_13.png'),
            },
            {
              title: '江苏省阜宁中等专业学校',
              text: '江苏省阜宁中等专业学校学校位于江苏省盐城市阜宁县，学校先后获得了全国德育管理先进学校、全国劳动力转移培训先进单位、江苏省职业教育先进单位、江苏省诚信办学规范管理示范学校、盐城市依法治校先进学校、盐城市教育工作改革创新先进单位、盐城市技能大赛先进单位、阜宁县综合先进单位等多...',
              src: require('../../assets/img/case/zhxy_image_14.png'),
            },
            {
              title: '盐城市第一中学',
              text: '盐城市第一中学，始建于1923年，初名“盐城县立初级中学”，由陈毅委托著名革命教育家赵敬之创立，是盐城地区第一所公立中学，1990年，首批通过江苏省重点高中评估验收；2001年，通过国家级示范性高中评估验收2003年11月，顺利转评为江苏省首批四星级高中。',
              src: require('../../assets/img/case/zhxy_image_15.png'),
            },
            {
              title: '海陵中学',
              text: '海陵中学是由江苏省海安高级中学参与举办的一所股份制民办学校，也称海中分校。现已于2011年正式成为国家公办学校。学校具有丰厚的办学底蕴。历史名校、国家级示范高中——海安高级中学，教学业绩蜚声省内外，曾培育了多名全省高考状元和国际中学生奥赛金牌得主.',
              src: require('../../assets/img/case/zhxy_image_16.png'),
            },
            {
              title: '连云港东港中学',
              text: '连云港市东港中学创建于1989年，每年约有初中教学班的40个，在校学生1700多人，教职工约150人，其中中学高级教师约20人、中学一级教师约70人。',
              src: require('../../assets/img/case/zhxy_image_17.png'),
            },
            {
              title: '睢宁县菁华高级中学',
              text: '睢宁县菁华高级中学（Suining Jinghua Senior High School）建立于2001年，占地135亩，建筑面积约7万平米，设备设施先进，环境优美，风格独特。学校拥有专职教师170余名，其中，市县级学科带头人15人，高级以上职称34人，在校学生近3000人。',
              src: require('../../assets/img/case/zhxy_image_18.png'),
            },
          ],
        },
        2: {
          20: [
            {
              title: '建行微应用人脸识别通道',
              text: '',
              src: require('../../assets/img/case/rlsb.png'),
            },
            {
              title: '建行无人值守无感支付停车',
              text: '',
              src: require('../../assets/img/case/tc.png'),
            },
            {
              title: '社区电瓶车智能充电桩',
              text: '',
              src: require('../../assets/img/case/cdz.png'),
            },
          ],
          21: [
            {
              title: '智慧大屏',
              text: '',
              src: require('../../assets/img/smart/zhdp_summary_Image.png'),
            },
          ],
          22: [
            {
              title: '智慧商超',
              text: '',
              src: require('../../assets/img/smart/sc_summary_Image.png'),
            },
          ],
        },
        3: {
          30: [
            {
              title: '智慧工地项目',
              text: '基于智慧工地物联网云平台与现场多个子系统的互联，实现现场各类工况数据采集、存储、分析与应用。通过接入智慧工地物联网云平台的多个子系统板块，根据现场管理实际需求灵活组合，实现一体化、模块化、智能化、网络化的施工现场过程全面感知、协同工作智能分析、风险预控、知识共享、互联互通等业务，全面满足建筑施工企业精细化管理...',
              src: require('../../assets/img/case/zhgd_image.png'),
            },
          ],
        },
        4: {
          40: [
            {
              title: '韩城全域旅游项目',
              text: '陕西省韩城全域旅游主要将6大村子，司马迁祠、明清古城、党家村、梁带村国家遗址公园、文庙、黄河湿地等人文历史与自然景观的完美结合、将各产业、各行业的深度融合打造“关中水乡、宜居韩城”。',
              src: require('../../assets/img/case/zhjq1_image.png'),
            },
          ],
          41: [
            {
              title: '黄陵全域旅游项目',
              text: '黄陵县推行“旅游+N”模式，提升黄陵全域旅游的品牌效应，推动黄陵旅游从“一日游”向“多日游”、“过境地”向“目的地”转变，加快了旅游产业转型升级。',
              src: require('../../assets/img/case/zhjq2_image.png'),
            },
          ],
          42: [
            {
              title: '万泉湖智慧旅游项目',
              text: '万泉湖风村子位于林州市南部的淇、淅河交汇处。是国家AAAA级民俗村，这里有淇淅河国家湿地公园，有豫北最大的涌泉群——石门涌泉。 大小泉眼数不胜数，生生不息，汇流成了一条波光粼粼的泱泱湖泊——故名万泉湖，万泉湖风村子数字化项目的建成，对村子管理和服务能力提升，以及对万泉湖对自然风景的保护，都起到良好的促进作用。',
              src: require('../../assets/img/case/zhjq3_image.png'),
            },
          ],
        },
      },
    };
  },
  methods: {
    toDeatil(title) {
      let query = {
        title: title,
      };
      this.$router.push({ path: '/case/casedetail', query });
    },
    changeTab(index) {
      this.current = index;
      this.current1 = 0;
    },
    changeTab1(index) {
      this.current1 = index;
    },
    toAll() {
      this.activebread = 0;
      let obj = {
        10: [
          {
            title: '巢湖学院',
            text: '安徽巢湖学院是安徽省属全日制公办本科高校。创建于1977年，前身是巢湖师范专科学校。2002年4月，经教育部批准，升格为本科院校，更名巢湖学院。2006年6月，获批学士学位授予权。2013年6月，顺利通过教育部本科教学工作合格评估。2018年12月，参与教育部本科教学工作审核评估，并获好评。2019年10月，获批...',
            src: require('../../assets/img/case/zhxy_image_0.png'),
          },
          {
            title: '上海工商职业技术学院',
            text: '上海工商职业技术学院（Shanghai Industrial and Commercial Polytechnic），前身为上海新侨职业技术学院，创建于1993年，由上海海外联谊会、上海市海外交流协会、上海市归国华侨联合会、上海中华职业教育社、上海市工商业联合会、中国民主建国会上海市委员会等六个统战系统的社会团体及民主党派共...',
            src: require('../../assets/img/case/zhxy_image_1.png'),
          },
          {
            title: '江苏省盐城技师学院',
            text: '学校创办于上世纪八十年代初期，1994年被国家劳动部评定为全国首批国家级重点技工学校，2007年经江苏省人民政府批准为全省首批副厅级重点技师学院，更名为“江苏省盐城技师学院”。2008年1月增挂江苏联合职业技术学院盐城技师分院校牌。2020年3月，盐城交通技师学院并入江苏省盐城技师学院。',
            src: require('../../assets/img/case/zhxy_image_2.png'),
          },
          {
            title: '盐城生物工程高等职业技术学校',
            text: '盐城生物工程高等职业技术学校（江苏联合职业技术学院盐城生物工程分院），是国家中等职业教育改革发展示范学校、江苏省现代化示范性职业学校、江苏省农业紧缺人才培训基地、江苏省退役士兵职业技能培训学院。 学校前身为“江苏省盐城农业学校”，创办于1952年，1958年创办“江苏盐城农学院...',
            src: require('../../assets/img/case/zhxy_image_3.png'),
          },
          {
            title: '江苏省姜堰中学',
            text: '江苏省姜堰中学（Jiangyan High Schoolof Jiangsu Province），国家级示范性高中、江苏省重点高中、江苏省四星级高中。江苏省姜堰中学创办于1939年，历经三水初级中学、泰县私立荣汉初级中学、存容学塾、苏中姜堰初级中学、泰县姜堰中学等的传承演变。1996年被省教委命名为江苏省姜堰中...',
            src: require('../../assets/img/case/zhxy_image_4.png'),
          },
          {
            title: '江苏省丹阳高级中学',
            text: '江苏省丹阳高级中学（Danyang Senior High School of Jiangsu Province），简称“省丹中”，坐落于江苏省丹阳市，由丹阳市教育局举办，是首批国家级示范高中、江苏省首批四星级高中、江苏省首批重点中学、江苏省创新拔尖人才培养试点学校、江苏省首批高品质示范高中南京大学创新人才培养战略合作伙伴、江苏...',
            src: require('../../assets/img/case/zhxy_image_5.png'),
          },
          {
            title: '江苏省射阳中学',
            text: '江苏省射阳中学（Jiangsu Province Sheyang High School），简称“省射中”，位于江苏省射阳县新城区幸福大道28号。学校是首批国家级示范高中、首批江苏省四星级高中。江苏省射阳中学创办于1943年2月，最初校名为“盐东县立初级中学“，后几经更名。1956年夏，增设高中部，更名为“射阳县中...',
            src: require('../../assets/img/case/zhxy_image_6.png'),
          },
        ],
        11: [
          {
            title: '兴洪中学',
            text: '兴洪中学创办于1994年6月，开苏北民办教育之先河，是宿迁市第一所民办学校。2006年1月，兴洪中学被江苏省教育厅评定为省重点中学，是泗洪县众多民办学校中唯一一家省重点中学。学校位于县城西郊，东邻省道徐宁路西望宁宿徐高速公路，南面是正在崛起的泗洪工业园区，地理位置优越，交通便利，环境...',
            src: require('../../assets/img/case/zhxy_image_7.png'),
          },
          {
            title: '江苏省阜宁中学',
            text: '江苏省阜宁中学（Jiangsu Funing Middle School），简称“阜中”，位于江苏省盐城市阜宁县。学校创办于1923年，1952年学校经江苏省教育厅批准正式定名为江苏省阜宁中学。2001年4月被江苏省教育厅确认为国家级示范高中，2004年3月转评为江苏省四星级高中。',
            src: require('../../assets/img/case/zhxy_image_8.png'),
          },
          {
            title: '江苏省阜宁县实验初级中学',
            text: '阜宁县实验初级中学位于阜宁县城南新区。校区占地228亩，总投资额1.68亿元，办学规模为20轨60个班。新校区交通便捷，设施齐全环境幽雅，气势恢弘，堪称苏北一流的现代化校园。学校先后获得省绿色学校、省优秀教师群体、省和谐教育先进集体、省实施教育现代化工程示范初中、省初中物理学科实验基地...',
            src: require('../../assets/img/case/zhxy_image_9.png'),
          },
          {
            title: '江苏省亭湖高级中学',
            text: '江苏省亭湖高级中学位于盐城市亭湖新区，亭湖大道北侧、兴洋大道东侧，与亭湖区政府隔街相望。2012年盐城市亭湖区政府在盐城市亭湖新区重点打造的民生工程，江苏省亭湖高级中学建成投入使用，盐城市景山中学高中部东迁到新校区，新校区建设“立足四星标准、留足五星空间”，最终打造成全省一流...',
            src: require('../../assets/img/case/zhxy_image_10.png'),
          },
          {
            title: '启动市折桂中学',
            text: '启东折桂中学位于启东市汇龙镇民乐中路580号，占地面积57168平方米（85.7亩），现有班级38个，教职工186人，在校学生总数2000多人。启东折桂中学于2004年在原江苏省启东中学初中部（民办）的基础上创办，2011年春改制为公办学校。2015年3月与江苏省启东中学剥离，正...',
            src: require('../../assets/img/case/zhxy_image_11.png'),
          },
          {
            title: '南通市通州区育才中学',
            text: '南通市通州区育才中学位于江苏省南通市通州区金沙镇，原系江苏省通州高级中学的初中部。2000年经南通市教育局批准为全日制民办中学，2006年8月搬迁南通高新技术产业开发区银河路21号独立办学，2010年下半年学校“回归公办”。 [1]  2014年9月，学校搬迁至新校区。',
            src: require('../../assets/img/case/zhxy_image_12.png'),
          },
        ],
        12: [
          {
            title: '江苏省南通田家炳中学',
            text: '江苏省南通田家炳中学（Nantong Tianjiabing Middle School of Jiangsu Province）位于江苏省南通市，学校是由南通市教育局举办的一所公办初级中学。学校始建于1952年，时名苏北工人技术学校。1954年，更名为“南通市第一初级中学”。 1958年，更名为南通市第三中学。2002年...',
            src: require('../../assets/img/case/zhxy_image_13.png'),
          },
          {
            title: '江苏省阜宁中等专业学校',
            text: '江苏省阜宁中等专业学校学校位于江苏省盐城市阜宁县，学校先后获得了全国德育管理先进学校、全国劳动力转移培训先进单位、江苏省职业教育先进单位、江苏省诚信办学规范管理示范学校、盐城市依法治校先进学校、盐城市教育工作改革创新先进单位、盐城市技能大赛先进单位、阜宁县综合先进单位等多...',
            src: require('../../assets/img/case/zhxy_image_14.png'),
          },
          {
            title: '盐城市第一中学',
            text: '盐城市第一中学，始建于1923年，初名“盐城县立初级中学”，由陈毅委托著名革命教育家赵敬之创立，是盐城地区第一所公立中学，1990年，首批通过江苏省重点高中评估验收；2001年，通过国家级示范性高中评估验收2003年11月，顺利转评为江苏省首批四星级高中。',
            src: require('../../assets/img/case/zhxy_image_15.png'),
          },
          {
            title: '海陵中学',
            text: '海陵中学是由江苏省海安高级中学参与举办的一所股份制民办学校，也称海中分校。现已于2011年正式成为国家公办学校。学校具有丰厚的办学底蕴。历史名校、国家级示范高中——海安高级中学，教学业绩蜚声省内外，曾培育了多名全省高考状元和国际中学生奥赛金牌得主.',
            src: require('../../assets/img/case/zhxy_image_16.png'),
          },
          {
            title: '连云港东港中学',
            text: '连云港市东港中学创建于1989年，每年约有初中教学班的40个，在校学生1700多人，教职工约150人，其中中学高级教师约20人、中学一级教师约70人。',
            src: require('../../assets/img/case/zhxy_image_17.png'),
          },
          {
            title: '睢宁县菁华高级中学',
            text: '睢宁县菁华高级中学（Suining Jinghua Senior High School）建立于2001年，占地135亩，建筑面积约7万平米，设备设施先进，环境优美，风格独特。学校拥有专职教师170余名，其中，市县级学科带头人15人，高级以上职称34人，在校学生近3000人。',
            src: require('../../assets/img/case/zhxy_image_18.png'),
          },
        ],
      };
      this.$set(this.caseItem, 1, obj);
    },
    toCollege() {
      this.activebread = 1;
      this.pageList = ['1'];
      let obj = {
        10: [
          {
            title: '巢湖学院',
            text: '安徽巢湖学院是安徽省属全日制公办本科高校。创建于1977年，前身是巢湖师范专科学校。2002年4月，经教育部批准，升格为本科院校，更名巢湖学院。2006年6月，获批学士学位授予权。2013年6月，顺利通过教育部本科教学工作合格评估。2018年12月，参与教育部本科教学工作审核评估，并获好评。2019年10月，获批...',
            src: require('../../assets/img/case/zhxy_image_0.png'),
          },
          {
            title: '上海工商职业技术学院',
            text: '上海工商职业技术学院（Shanghai Industrial and Commercial Polytechnic），前身为上海新侨职业技术学院，创建于1993年，由上海海外联谊会、上海市海外交流协会、上海市归国华侨联合会、上海中华职业教育社、上海市工商业联合会、中国民主建国会上海市委员会等六个统战系统的社会团体及民主党派共...',
            src: require('../../assets/img/case/zhxy_image_1.png'),
          },
          {
            title: '江苏省盐城技师学院',
            text: '学校创办于上世纪八十年代初期，1994年被国家劳动部评定为全国首批国家级重点技工学校，2007年经江苏省人民政府批准为全省首批副厅级重点技师学院，更名为“江苏省盐城技师学院”。2008年1月增挂江苏联合职业技术学院盐城技师分院校牌。2020年3月，盐城交通技师学院并入江苏省盐城技师学院。',
            src: require('../../assets/img/case/zhxy_image_2.png'),
          },
          {
            title: '盐城生物工程高等职业技术学校',
            text: '盐城生物工程高等职业技术学校（江苏联合职业技术学院盐城生物工程分院），是国家中等职业教育改革发展示范学校、江苏省现代化示范性职业学校、江苏省农业紧缺人才培训基地、江苏省退役士兵职业技能培训学院。 学校前身为“江苏省盐城农业学校”，创办于1952年，1958年创办“江苏盐城农学院...',
            src: require('../../assets/img/case/zhxy_image_3.png'),
          },
        ],
      };
      this.$set(this.caseItem, 1, obj);
    },
    toSchool() {
      this.activebread = 2;
      let obj = {
        10: [
          {
            title: '江苏省姜堰中学',
            text: '江苏省姜堰中学（Jiangyan High Schoolof Jiangsu Province），国家级示范性高中、江苏省重点高中、江苏省四星级高中。江苏省姜堰中学创办于1939年，历经三水初级中学、泰县私立荣汉初级中学、存容学塾、苏中姜堰初级中学、泰县姜堰中学等的传承演变。1996年被省教委命名为江苏省姜堰中...',
            src: require('../../assets/img/case/zhxy_image_4.png'),
          },
          {
            title: '江苏省丹阳高级中学',
            text: '江苏省丹阳高级中学（Danyang Senior High School of Jiangsu Province），简称“省丹中”，坐落于江苏省丹阳市，由丹阳市教育局举办，是首批国家级示范高中、江苏省首批四星级高中、江苏省首批重点中学、江苏省创新拔尖人才培养试点学校、江苏省首批高品质示范高中南京大学创新人才培养战略合作伙伴、江苏...',
            src: require('../../assets/img/case/zhxy_image_5.png'),
          },
          {
            title: '江苏省射阳中学',
            text: '江苏省射阳中学（Jiangsu Province Sheyang High School），简称“省射中”，位于江苏省射阳县新城区幸福大道28号。学校是首批国家级示范高中、首批江苏省四星级高中。江苏省射阳中学创办于1943年2月，最初校名为“盐东县立初级中学“，后几经更名。1956年夏，增设高中部，更名为“射阳县中...',
            src: require('../../assets/img/case/zhxy_image_6.png'),
          },
          {
            title: '兴洪中学',
            text: '兴洪中学创办于1994年6月，开苏北民办教育之先河，是宿迁市第一所民办学校。2006年1月，兴洪中学被江苏省教育厅评定为省重点中学，是泗洪县众多民办学校中唯一一家省重点中学。学校位于县城西郊，东邻省道徐宁路西望宁宿徐高速公路，南面是正在崛起的泗洪工业园区，地理位置优越，交通便利，环境...',
            src: require('../../assets/img/case/zhxy_image_7.png'),
          },
          {
            title: '江苏省阜宁中学',
            text: '江苏省阜宁中学（Jiangsu Funing Middle School），简称“阜中”，位于江苏省盐城市阜宁县。学校创办于1923年，1952年学校经江苏省教育厅批准正式定名为江苏省阜宁中学。2001年4月被江苏省教育厅确认为国家级示范高中，2004年3月转评为江苏省四星级高中。',
            src: require('../../assets/img/case/zhxy_image_8.png'),
          },
          {
            title: '江苏省阜宁县实验初级中学',
            text: '阜宁县实验初级中学位于阜宁县城南新区。校区占地228亩，总投资额1.68亿元，办学规模为20轨60个班。新校区交通便捷，设施齐全环境幽雅，气势恢弘，堪称苏北一流的现代化校园。学校先后获得省绿色学校、省优秀教师群体、省和谐教育先进集体、省实施教育现代化工程示范初中、省初中物理学科实验基地...',
            src: require('../../assets/img/case/zhxy_image_9.png'),
          },
        ],
        11: [
          {
            title: '江苏省亭湖高级中学',
            text: '江苏省亭湖高级中学位于盐城市亭湖新区，亭湖大道北侧、兴洋大道东侧，与亭湖区政府隔街相望。2012年盐城市亭湖区政府在盐城市亭湖新区重点打造的民生工程，江苏省亭湖高级中学建成投入使用，盐城市景山中学高中部东迁到新校区，新校区建设“立足四星标准、留足五星空间”，最终打造成全省一流...',
            src: require('../../assets/img/case/zhxy_image_10.png'),
          },
          {
            title: '启动市折桂中学',
            text: '启东折桂中学位于启东市汇龙镇民乐中路580号，占地面积57168平方米（85.7亩），现有班级38个，教职工186人，在校学生总数2000多人。启东折桂中学于2004年在原江苏省启东中学初中部（民办）的基础上创办，2011年春改制为公办学校。2015年3月与江苏省启东中学剥离，正...',
            src: require('../../assets/img/case/zhxy_image_11.png'),
          },
          {
            title: '南通市通州区育才中学',
            text: '南通市通州区育才中学位于江苏省南通市通州区金沙镇，原系江苏省通州高级中学的初中部。2000年经南通市教育局批准为全日制民办中学，2006年8月搬迁南通高新技术产业开发区银河路21号独立办学，2010年下半年学校“回归公办”。 [1]  2014年9月，学校搬迁至新校区。',
            src: require('../../assets/img/case/zhxy_image_12.png'),
          },
          {
            title: '江苏省南通田家炳中学',
            text: '江苏省南通田家炳中学（Nantong Tianjiabing Middle School of Jiangsu Province）位于江苏省南通市，学校是由南通市教育局举办的一所公办初级中学。学校始建于1952年，时名苏北工人技术学校。1954年，更名为“南通市第一初级中学”。 1958年，更名为南通市第三中学。2002年...',
            src: require('../../assets/img/case/zhxy_image_13.png'),
          },
          {
            title: '江苏省阜宁中等专业学校',
            text: '江苏省阜宁中等专业学校学校位于江苏省盐城市阜宁县，学校先后获得了全国德育管理先进学校、全国劳动力转移培训先进单位、江苏省职业教育先进单位、江苏省诚信办学规范管理示范学校、盐城市依法治校先进学校、盐城市教育工作改革创新先进单位、盐城市技能大赛先进单位、阜宁县综合先进单位等多...',
            src: require('../../assets/img/case/zhxy_image_14.png'),
          },
          {
            title: '盐城市第一中学',
            text: '盐城市第一中学，始建于1923年，初名“盐城县立初级中学”，由陈毅委托著名革命教育家赵敬之创立，是盐城地区第一所公立中学，1990年，首批通过江苏省重点高中评估验收；2001年，通过国家级示范性高中评估验收2003年11月，顺利转评为江苏省首批四星级高中。',
            src: require('../../assets/img/case/zhxy_image_15.png'),
          },
        ],
        12: [
          {
            title: '海陵中学',
            text: '海陵中学是由江苏省海安高级中学参与举办的一所股份制民办学校，也称海中分校。现已于2011年正式成为国家公办学校。学校具有丰厚的办学底蕴。历史名校、国家级示范高中——海安高级中学，教学业绩蜚声省内外，曾培育了多名全省高考状元和国际中学生奥赛金牌得主.',
            src: require('../../assets/img/case/zhxy_image_16.png'),
          },
          {
            title: '连云港东港中学',
            text: '连云港市东港中学创建于1989年，每年约有初中教学班的40个，在校学生1700多人，教职工约150人，其中中学高级教师约20人、中学一级教师约70人。',
            src: require('../../assets/img/case/zhxy_image_17.png'),
          },
          {
            title: '睢宁县菁华高级中学',
            text: '睢宁县菁华高级中学（Suining Jinghua Senior High School）建立于2001年，占地135亩，建筑面积约7万平米，设备设施先进，环境优美，风格独特。学校拥有专职教师170余名，其中，市县级学科带头人15人，高级以上职称34人，在校学生近3000人。',
            src: require('../../assets/img/case/zhxy_image_18.png'),
          },
        ],
      };
      this.$set(this.caseItem, 1, obj);
    },
    toprev() {
      if (this.pageList.length == 1) {
        return;
      }
      if (this.current1 == 0) {
        this.current1 == 0;
      } else {
        this.current1 -= 1;
      }
    },
    tonext() {
      if (this.pageList.length == 1) {
        return;
      }
      if (this.current1 == 2) {
        this.current1 = 2;
      } else {
        this.current1 += 1;
      }
    },
    tofirst() {
      this.current1 = 0;
    },
    toend() {
      this.current1 = this.pageList.length - 1;
    },
  },
};
</script>
<style scoped>
.news-banner {
  width: 100%;
  height: 594px;
  line-height: 594px;
  background: #000;
}
.news-banner div {
  width: 100%;
  height: 100%;
  background: url('../../assets/img/case/case_background_Image.png') no-repeat;
  background-size: cover;
}
.news-banner h2 {
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.news-nav {
  width: 100%;
  height: 100px;
  line-height: 100px;
  background-color: #eee;
}
.news-nav li {
  height: 100px;
  float: left;
  font-size: 36px;
  margin-right: 99px;
}
.news-nav li.current {
  border-bottom: 4px solid #0076de;
  font-size: 48px;
  line-height: 96px;
  font-weight: bold;
}
.news-nav li:nth-child(1) {
  margin-left: 50px;
}
.news-list ul.showBox {
  display: block;
}
.news-list li {
  width: 100%;
  /* height: 311px; */
  margin-bottom: 40px;
}
.news-page {
  margin-top: 45px;
  margin-bottom: 85px;
  font-size: 18px;
  font-weight: 400;
  color: #333;
}
.news-page ul li {
  float: left;
  margin-right: 20px;
}
.news-page ul li a {
  display: block;
  padding: 20px 25px;
  background: #ffffff;
  box-shadow: 0px 3px 13px 5px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
}
.news-page ul li.current a {
  background: #0076de;
  color: #fff;
}
.back-index {
  width: 140px;
}
.news-page ul li:nth-child(1) {
  margin-left: 192px;
}
.back-index a {
  text-align: center;
}
.home-recdyc {
  width: 1200px;
}
.content {
  margin-bottom: 50px;
  box-shadow: 0px 0px 30px 2px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
}
.content-l {
  width: 750px;
  height: 422px;
}
.content-l img {
  width: 100%;
  height: 100%;
}
.content-r {
  padding-top: 50px;
  padding-right: 40px;
  width: 400px;
}
.content-r h2 {
  margin-bottom: 40px;
  text-align: center;
  color: #333;
  font-size: 30px;
}
.content-r p {
  text-indent: 2em;
  font-size: 18px;
  color: #666;
  line-height: 1.7;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  overflow: hidden;
}
.bread {
  background-color: #f7f7f7;
  border-radius: 10px;
  padding: 30px;
}
.bread span {
  font-size: 26px;
  color: #666;
  cursor: pointer;
}
.bread .active-span {
  font-size: 36px;
  border-bottom: 4px solid #0076de;
  font-weight: bold;
  padding-bottom: 20px;
}
</style>
